<ng-container *ngIf="loading">
    <div class="content-centered-column">
        <div class="content-centered-row">
            <ion-spinner></ion-spinner>
        </div>
    </div>
</ng-container>


<ion-button *ngIf="!chatGroup.pivot_notifications_muted"
            color="warning"
            (click)="muteNotifications()">
    {{ 'BUTTON_CHAT_GROUP_MUTE_NOTIFICATIONS' | translate }}
</ion-button>

<ion-button *ngIf="chatGroup.pivot_notifications_muted"
            color="primary"
            (click)="unmuteNotifications()">
    {{ 'BUTTON_CHAT_GROUP_UNMUTE_NOTIFICATIONS' | translate }}
</ion-button>
